import { render, staticRenderFns } from "./CertificateLeading.vue?vue&type=template&id=f05768ba&scoped=true"
import script from "./CertificateLeading.vue?vue&type=script&lang=js"
export * from "./CertificateLeading.vue?vue&type=script&lang=js"
import style0 from "./CertificateLeading.vue?vue&type=style&index=0&id=f05768ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05768ba",
  null
  
)

export default component.exports